import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { DepreciationSchedule, DepreciationScheduleCreate, DepreciationScheduleFilter } from '../data/depreciationSchedule';

export function createDepreciationScheduleService(client: AxiosInstance) {
  return createCrudService<DepreciationSchedule, DepreciationScheduleCreate, DepreciationScheduleFilter>(
    client,
    '/asset-management/DepreciationSchedule',
    'id',
  );
}

export type DepreciationScheduleService = CrudService<DepreciationSchedule, DepreciationScheduleCreate, DepreciationScheduleFilter>;
